import { ADMIN_SCOPES } from '../constants/admin_scope_constants';

/**
 * Check if the user has at least one of the required scopes.
 * Users with the ALL scope always pass.
 *
 * @param {string[]} adminScopes - The user's current scopes array
 * @param {...string} requiredScopes - One or more scopes to check against
 * @returns {boolean}
 */
export const hasScope = (adminScopes, ...requiredScopes) => {
  if (adminScopes.includes(ADMIN_SCOPES.ALL)) return true;
  return requiredScopes.some(scope => adminScopes.includes(scope));
};
